// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/1.4.0/css/" + chunkId + "." + "ab4ee970" + ".chunk.css";
};